"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _Info = _interopRequireDefault(require("../figure/Info"));
var _UnreachableCaseError = require("../../entities/UnreachableCaseError");
var _Done = require("../figure/Done");
var _Warning = require("../figure/Warning");
var _Declined = require("../figure/Declined");
var _Title = _interopRequireDefault(require("../primitive/Title"));
var _Button = require("../action/Button");
var getColor = function getColor(variant, theme) {
  switch (variant) {
    case 'info':
      return 'transparent';
    case 'success':
      return theme.colors.positive['40'];
    case 'error':
      return theme.colors.negative['60'];
    case 'warn':
      return theme.colors.warning['30'];
    default:
      throw new _UnreachableCaseError.UnreachableCaseError(variant);
  }
};
var getIcon = function getIcon(variant) {
  switch (variant) {
    case 'info':
      return /*#__PURE__*/_react["default"].createElement(_Info["default"], null);
    case 'success':
      return /*#__PURE__*/_react["default"].createElement(_Done.Done, null);
    case 'warn':
      return /*#__PURE__*/_react["default"].createElement(_Warning.Warning, null);
    case 'error':
      return /*#__PURE__*/_react["default"].createElement(_Declined.Declined, null);
    default:
      throw new _UnreachableCaseError.UnreachableCaseError(variant);
  }
};
var Toast = function Toast(_ref) {
  var title = _ref.title,
    children = _ref.children,
    actions = _ref.actions,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'info' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  var stylingProps = {
    variant: variant,
    size: size
  };
  return /*#__PURE__*/_react["default"].createElement(Container, stylingProps, /*#__PURE__*/_react["default"].createElement(Content, stylingProps, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    variant: "tiny"
  }, getIcon(variant), title), children), actions && /*#__PURE__*/_react["default"].createElement(Buttons, stylingProps, actions));
};
var Content = _styledComponents["default"].div.withConfig({
  displayName: "Toast__Content",
  componentId: "sc-1kfw2l9-0"
})(["flex:1;padding:", ";svg{margin-right:0.6rem;position:relative;top:0.3rem;}h4{margin-bottom:0.4rem;}"], function (_ref2) {
  var size = _ref2.size;
  return size === 'medium' ? '1.6rem 2.8rem' : '1.2rem 2rem';
});
var Buttons = _styledComponents["default"].div.withConfig({
  displayName: "Toast__Buttons",
  componentId: "sc-1kfw2l9-1"
})(["padding:", ";"], function (_ref3) {
  var size = _ref3.size;
  return size === 'medium' ? '1.2rem 2.8rem 1.2rem 0rem' : '0 2rem 1.2rem 2rem';
});
var Container = _styledComponents["default"].div.withConfig({
  displayName: "Toast__Container",
  componentId: "sc-1kfw2l9-2"
})(["max-width:", ";width:100%;background:", ";display:flex;flex-direction:", ";align-items:", ";border:1px solid ", ";border-radius:2px;:after{width:0.4rem;content:'';position:absolute;left:0;bottom:0;top:0;background:", ";}", "{min-width:9.5rem;}"], function (_ref4) {
  var size = _ref4.size;
  return size === 'medium' ? '51.1rem' : '38.8rem';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.neutral['0'];
}, function (_ref6) {
  var size = _ref6.size;
  return size === 'medium' ? 'row' : 'column';
}, function (_ref7) {
  var size = _ref7.size;
  return size === 'medium' ? 'center' : 'unset';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.neutral['30'];
}, function (_ref9) {
  var theme = _ref9.theme,
    variant = _ref9.variant;
  return getColor(variant, theme);
}, _Button.StyledButton);
var _default = exports["default"] = Toast;
//# sourceMappingURL=Toast.js.map